import { styledComponent, Typography } from '@hermes/web-components'

export const RatePaperMobileTypography = styledComponent(Typography)(({ theme }) => ({
  ...theme.custom.SearchProfileCard.mobile.subtitleText,
  width: '90%',
  lineHeight: '20px'
}))
